// Decodes a JWT's `exp` claim without verifying the signature — this is
// only ever used client-side to decide when to proactively refresh or
// whether a stored token is stale, never to trust the token's contents.
// The server (telik-auth-service) is the actual source of truth for
// validity; this is purely a UX optimization.
export function decodeJwtExpiryMs(token: string): number | null {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    const decoded = JSON.parse(json) as { exp?: number };
    return typeof decoded.exp === 'number' ? decoded.exp * 1000 : null;
  } catch {
    return null;
  }
}

export function isJwtExpired(token: string): boolean {
  const expiryMs = decodeJwtExpiryMs(token);
  // A token whose expiry can't be read is treated as not-expired here —
  // the server will still reject it on the next real request if it's
  // actually bad; this check exists to catch the common case fast, not to
  // be the final authority.
  return expiryMs !== null && expiryMs <= Date.now();
}
